var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 60,
    viewBox: "0 0 40 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M20.284 59.988H0v-60h11.044v39.557a7.327 7.327 0 1 0 7.325-7.481 7.194 7.194 0 0 0-4.4 1.5V-.007h7.1A13.632 13.632 0 0 1 34.56 13.764a13.865 13.865 0 0 1-4.541 10.306 19.409 19.409 0 0 1 9.2 16.586 19.137 19.137 0 0 1-18.934 19.335z",
    transform: "translate(0 0.008)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBLogo);
export default __webpack_public_path__ + "static/media/b-logo.5ce332b8149a48878202823fb5da666d.svg";
export { ForwardRef as ReactComponent };